import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const softwareDeploymentsEntrypoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-deployments-entrypoint" */ './src'),
	),
	getPreloadProps: () => ({}),
});
